import {
    Button,
    Paper,
    Popper,
    TextField,
    Typography,
    useAlert
} from "matsuri-ui"
import { css } from "@emotion/react"
import { useQRCode } from "next-qrcode"
import { useState } from "react"
import {
    Android,
    Apple,
    ContentCopy,
    Language,
    QrCode
} from "@mui/icons-material"
import { copyToClipboard } from "@/helpers/copyToClipboard"

const IOS_APP_URL = "https://apps.apple.com/us/app/m2m-cleaning/id6743433333"
const ANDROID_APP_URL =
    "https://play.google.com/store/apps/details?id=tech.matsuri.cleaning"

export const ShowCleanerPageQrCode = () => {
    const [anchorEl, setAnchorEl] = useState<Element | null>(null)
    const open = Boolean(anchorEl)
    const handleClick = ({ currentTarget }: React.SyntheticEvent) => {
        setAnchorEl(prev => (prev ? null : currentTarget))
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const { Canvas: RenderQrCode } = useQRCode()

    const webHref =
        process.env.NODE_ENV === "production"
            ? "https://cleaner-cleaning.m2msystems.cloud"
            : "https://matsuri-tech-m2m-cleaning-cleaner-front-dev.vercel.app"

    const links = [
        {
            label: "清掃員向けiOSアプリはこちら",
            url: IOS_APP_URL,
            icon: <Apple />
        },
        {
            label: "清掃員向けAndroidアプリはこちら",
            url: ANDROID_APP_URL,
            icon: <Android />
        },
        { label: "清掃員向けweb画面はこちら", url: webHref, icon: <Language /> }
    ]

    const { addAlert } = useAlert()

    return (
        <div>
            <Button rounded icon={<QrCode />} onClick={handleClick} />
            <Popper
                anchorEl={anchorEl}
                open={open}
                onClickOutside={handleClose}
            >
                <Paper
                    css={css`
                        padding: 16px;
                    `}
                >
                    <div
                        css={css`
                            display: grid;
                            grid-template-columns: repeat(3, 1fr);
                            gap: 24px;

                            @media (max-width: 768px) {
                                grid-template-columns: 1fr;
                            }
                        `}
                    >
                        {links.map(({ label, url, icon }) => (
                            <div
                                key={label}
                                css={css`
                                    display: grid;
                                    gap: 16px;
                                `}
                            >
                                <Typography
                                    css={css`
                                        display: flex;
                                        gap: 4px;
                                        align-items: center;
                                    `}
                                >
                                    {icon}
                                    {label}
                                </Typography>

                                <div
                                    css={css`
                                        display: grid;
                                        justify-content: center;
                                    `}
                                >
                                    <RenderQrCode
                                        text={url}
                                        options={{
                                            errorCorrectionLevel: "M",
                                            margin: 0
                                        }}
                                    />
                                </div>

                                <div
                                    css={css`
                                        display: grid;
                                        grid-template-columns: 1fr auto;
                                        gap: 8px;
                                        align-items: center;
                                    `}
                                >
                                    <TextField value={url} readOnly />

                                    <Button
                                        icon={<ContentCopy />}
                                        onClick={() => {
                                            void copyToClipboard(url, {
                                                onSuccess: () => {
                                                    addAlert(
                                                        "クリップボードにコピーしました",
                                                        {
                                                            severity: "success"
                                                        }
                                                    )
                                                }
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </Paper>
            </Popper>
        </div>
    )
}
